import * as React from 'react';
import { forwardRef, } from 'react';
import { useCheckbox } from '../hooks/useCheckoutBox';
import { CheckProps,  } from 'tea-component';
export interface CheckboxProps<B = Boolean> extends CheckProps {
  // 是否只读
  readOnly: B;
  // 任意元素
  children: React.ReactNode;
}
export interface CheckboxChangeEventTarget<B = unknown> extends CheckboxProps {
  // Tea组件缺失这个属性，ali-react-table源码(packages\ali-react-table\src\pipeline\features\multiSelect.tsx)需要用到这个字段，所以额外新建一个多选组件
  checked: B | undefined;
}
// 注意这个组件，只能用于被继承于底层aliTable组件,没有其他功能
export const CheckboxExclusiveAli = forwardRef<HTMLSpanElement, Partial<CheckboxChangeEventTarget<Boolean>>>(
  ({ name, checked, value = '', onChange, disabled, indeterminate }, ref) => {
    const { state, getInputProps, htmlProps } = useCheckbox({
      name,
      value,
      disabled,
      checked,
      indeterminate,
      onChange,
    });
    const inputProps = getInputProps({});
    return (
      <label
        {...htmlProps}
      >
        <input
          ref={(input) => {
            if (input) {
              input.indeterminate = indeterminate as boolean;
            }
          }}
          type="checkbox"
          onClick={onChange}
          {...inputProps}
        />
      </label>
    );
  },
);

